<template>
    <modal v-model="showLoginPrompt" headerText="Please log in to view your data">
        <template slot="modal-body">

            <div class="modal-content p-4">
                <p>You need to sign in to view this page</p>
                <div @click="logIn" class="button-outline-rounded small text-center mt-2">
                    Sign in <span class="icon-lock"></span>
                </div>
                <p class="mt-4">Haven't registered yet?</p>
                <div @click="register" class="button-outline-rounded small text-center mt-2">
                    Register <span class="icon-edit"></span>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import modal from './layout/Modal.vue';

export default {
    components: { modal },
    methods: {
        logIn () {
            this.$router.push('/login');
            this.showLoginPrompt = false;
        },
        register () {
            this.$router.push('/register');
            this.showLoginPrompt = false;
        },
    },
    computed: {
        loggedInUser () {
            return this.$store.getters.loggedInUser;
        },
        showLoginPrompt: {
            get () {
                return this.$store.getters.showLoginPrompt;
            },
            set (val) {
                this.$store.commit('setShowLoginPrompt', val);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-card {
    height: auto !important;
}
</style>
